import { render, staticRenderFns } from "./writeXaIn.vue?vue&type=template&id=9edbb2c0&scoped=true"
import script from "./writeXaIn.vue?vue&type=script&lang=js"
export * from "./writeXaIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edbb2c0",
  null
  
)

export default component.exports